import { SvgIcon, useTheme } from '@mui/material';

import { getIconComponent } from '@/components/Icon/icon-mapper';

import { IconProps } from './Icon.interface';

export function Icon({ name, color, size = 24, ...props }: IconProps) {
  const theme = useTheme();

  const IconComponent = getIconComponent(name);

  return (
    <SvgIcon
      data-test-name={name}
      component={IconComponent}
      htmlColor={
        typeof color === 'function'
          ? color(theme)
          : (color ?? theme.palette.text.primary)
      }
      inheritViewBox
      sx={{ width: size, height: size }}
      {...props}
    />
  );
}
